function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "item-info_inline_svg__Group_529",
  "data-name": "Group 529",
  transform: "translate(-661.965 -177.932)"
}, /*#__PURE__*/React.createElement("g", {
  id: "item-info_inline_svg__Ellipse_216",
  "data-name": "Ellipse 216",
  transform: "translate(664 179)",
  fill: "#070556",
  stroke: "#707070",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 6.5,
  cy: 6.5,
  r: 6.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 6.5,
  cy: 6.5,
  r: 6,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  id: "item-info_inline_svg__Icon_ionic-md-information-circle",
  "data-name": "Icon ionic-md-information-circle",
  d: "M11.721 3.375a8.346 8.346 0 108.346 8.346 8.35 8.35 0 00-8.346-8.346zm.843 12.52h-1.685v-5.016h1.685zm0-6.661h-1.685V7.548h1.685z",
  transform: "translate(658.59 174.557)",
  fill: "#fdf7ec"
}));

function SvgItemInfoinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.693,
    height: 16.693,
    viewBox: "0 0 16.693 16.693"
  }, props), _ref);
}

export default SvgItemInfoinline;